import { LocalStoragePlus } from 'vtils'
import { ref, watch } from '@vue/composition-api'

export function useLocalStorage<T>(
  key: string,
  defaultValue: T,
  preferValue?: T,
) {
  const lsp = new LocalStoragePlus<T>({
    key: key,
  })
  const value = ref<T>(preferValue ?? lsp.get() ?? defaultValue)
  watch(
    value,
    () => {
      lsp.set(value.value as any)
    },
    {
      immediate: true,
    },
  )
  return value
}
